import { render, staticRenderFns } from "./TrainingNbCustomersMaxSettings.vue?vue&type=template&id=5710e7f6&"
import script from "./TrainingNbCustomersMaxSettings.vue?vue&type=script&lang=js&"
export * from "./TrainingNbCustomersMaxSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports